export default __webpack_public_path__ + "static/media/picture-default.042eb332.jpeg";